import React from 'react';

const IntersectionSymbol = () => {
	return (
		<>
			<div className="symmetric-difference-symbol">&#8853;</div>
		</>
	);
};

export default IntersectionSymbol;
